<select
  class="ag-grid-filter-dropdown"
  sizing="sm"
  cSelect
  (change)="onValueChanged($event)">
  <option value="">Choose...</option>
  <option
    *ngFor="let item of filters"
    [value]="item.key"
    [selected]="currentValue === item.key">
    {{ item.value }}
  </option>
</select>
